export const paymentCardInfo = {
	cashPayment: "À vista",
	installmentsPayment: "Parcelado",
	payment: "Pagamento",
};
